import Image from 'next/image';
import { AppNextLink } from '@/features/app-next-link';
import SubMenuContent from './sub-menu-content';
import { Categories } from '../../types';
import { closeMenuOnNavigate } from '../../utils/close-menu-on-navigate';
interface Props {
  title: string;
  icon: string;
  href?: string;
  id: string;
  isLinkInDrawer: boolean;
  subMenuChildren?: Categories[];
}
function SubMenuBox({
  icon,
  title,
  href,
  id,
  isLinkInDrawer,
  subMenuChildren
}: Props) {
  const containerClassName = 'flex border-spacing-px flex-col items-center justify-center gap-1 rounded border border-border-gray-medium bg-white py-2.5 text-text-black';
  return <div data-sentry-component="SubMenuBox" data-sentry-source-file="sub-menu-box.tsx">
            {isLinkInDrawer ? <AppNextLink href={href || ''} className={containerClassName} prefetch={false} onClick={closeMenuOnNavigate}>
                    <Image src={icon} alt={title} width={32} height={32} unoptimized />
                    <span className='text-xs font-medium'>{title}</span>
                </AppNextLink> : <label htmlFor={id} className={containerClassName}>
                    <Image src={icon} alt={title} width={32} height={32} unoptimized />
                    <span className='text-xs font-medium'>{title}</span>
                </label>}

            <input className={`peer/panel hidden`} id={id} type='checkbox' />

            <SubMenuContent title={title} id={id} subMenuChildren={subMenuChildren} parentMenuHref={href || ''} data-sentry-element="SubMenuContent" data-sentry-source-file="sub-menu-box.tsx" />
        </div>;
}
export default SubMenuBox;